import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/thedesperatetrader/app/news/[slug]/ArticleComments.tsx");
;
import(/* webpackMode: "eager" */ "/opt/thedesperatetrader/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/thedesperatetrader/src/components/article/TickerFocusPanel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/thedesperatetrader/src/components/ShareMenu.tsx");
